import SectionComponent from '@wix/thunderbolt-elements/src/components/Sections/Section/viewer/Section';
import SectionController from '@wix/thunderbolt-elements/src/components/Sections/Section/viewer/Section.controller';


const Section = {
  component: SectionComponent,
  controller: SectionController
};


export const components = {
  ['Section']: Section
};

